import * as React from 'react';

import {
  readScalarBand,
  paintScalarGeotiff,
  calculateBins,
  Histogram,
  readColorBand,
  paintColorGeotiff,
  ScalarBandInfo,
  ColorBandInfo
} from 'geotiff-utils';

type ChildreFn = (
  heatmapUrl: string | null,
  histogram: Histogram | null,
  bins: NdviRasterBins | null,
  loading: boolean
) => React.ReactNode;

interface Props {
  geotiffUrl: string | null;
  customBins: NdviRasterBins | null;
  children: ChildreFn;
  rasterMode: string;
}

interface State {
  heatmapUrl: string | null;
  geotiffUrl: string | null;
  histogram: Histogram | null;
  bins: NdviRasterBins | null;
  loading: boolean;
}

export default class GeotiffFetcher extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      loading: false,
      geotiffUrl: props.geotiffUrl,
      heatmapUrl: null,
      histogram: null,
      bins: props.customBins
    };
  }

  async executeProcess() {
    const { rasterMode } = this.props;
    const { geotiffUrl, bins } = this.state;

    this.setState({ loading: true });

    const response = await fetch(geotiffUrl as string);
    const buffer = await response.arrayBuffer();
    const canvas = document.createElement('canvas');

    let band: ScalarBandInfo | ColorBandInfo;
    let finalBins: NdviRasterBin[] | null = null;
    let histogram: Histogram | null = null;

    if (rasterMode === 'ndvi') {
      band = await readScalarBand(buffer);
      finalBins = bins || calculateBins(band.histogram);
      histogram = band.histogram;
      paintScalarGeotiff(band, canvas, finalBins);
    } else {
      console.log('painting color raster');
      band = await readColorBand(buffer);
      paintColorGeotiff(band, canvas);
    }

    const newHeatmapUrl = canvas.toDataURL();

    this.setState({
      loading: false,
      heatmapUrl: newHeatmapUrl,
      histogram: histogram,
      bins: finalBins
    });
  }

  updateState(newProps?: Props) {
    if (newProps && newProps.geotiffUrl) {
      if (
        this.props.geotiffUrl !== newProps.geotiffUrl ||
        this.props.customBins !== newProps.customBins
      ) {
        this.setState(
          {
            geotiffUrl: newProps.geotiffUrl,
            heatmapUrl: null,
            histogram: null,
            bins: newProps.customBins
          },
          async () => {
            await this.executeProcess();
          }
        );
      }
    }
  }

  componentWillReceiveProps(newProps: Props) {
    this.updateState(newProps);
  }

  componentDidMount() {
    this.updateState(this.props);
  }

  render() {
    const { children } = this.props;
    const { heatmapUrl, histogram, bins, loading } = this.state;
    return children(heatmapUrl, histogram, bins, loading);
  }
}



// WEBPACK FOOTER //
// ./src/providers/GeotiffProcessor.tsx